import { type SvgIconProps } from '@common/components/svgs/props';

function IconFlag(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Flag"
    >
      <g>
        <path
          d="M5 21V4h9l.4 2H20v10h-7l-.4-2H7v7H5Zm9.65-7H18V8h-5.25l-.4-2H7v6h7.25l.4 2Z"
          fill={`var(--${color})`}
        />
      </g>
    </svg>
  );
}

IconFlag.displayName = 'Flag';

export default IconFlag;
